import { render, staticRenderFns } from "./Form013aSemioGineco.vue?vue&type=template&id=50b4c05c"
import script from "./Form013aSemioGineco.vue?vue&type=script&lang=js"
export * from "./Form013aSemioGineco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports